import { render } from "./CompSectionPricePerfTubComponent.vue?vue&type=template&id=46af4f0c&scoped=true"
import script from "./CompSectionPricePerfTubComponent.vue?vue&type=script&lang=js"
export * from "./CompSectionPricePerfTubComponent.vue?vue&type=script&lang=js"

import "./CompSectionPricePerfTubComponent.vue?vue&type=style&index=0&id=46af4f0c&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46af4f0c"]])

export default __exports__